import { Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LimitedAssetRoomDTO } from '../../../../../../../../server/src/dto/asset-control.dto';
import { LanguageService } from '../../../../../shared/services/language/language.service';
import { AssetRoomService } from '../../services/asset-room.service';

@Component({
  selector: 'app-asset-room-select',
  templateUrl: './asset-room-select.component.html',
  styleUrls: ['./asset-room-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: AssetRoomSelectComponent,
    multi: true,
  }],
})
export class AssetRoomSelectComponent implements OnInit, ControlValueAccessor {
  private _onChange: (room: LimitedAssetRoomDTO) => void;
  private _onTouched: (room: LimitedAssetRoomDTO) => void;

  constructor(private _assetRoomsService: AssetRoomService,
              private _languageService: LanguageService) {
  }

  @Input()
  public displayOnly: boolean;

  @Input()
  public name: string;

  @Input()
  public placeholder: string;

  @Input()
  public rooms: LimitedAssetRoomDTO[];

  @Input()
  public required: boolean;

  public isDisabled: boolean;

  public selectedRoom: LimitedAssetRoomDTO;

  async ngOnInit() {
    this.rooms = this.rooms || await this._assetRoomsService.getRoomsAsync();

    this.placeholder = this.placeholder || await this._languageService.getTranslationAsync('Common.');
  }

  public onInnerChange(change: string) {
    this.selectedRoom = this.rooms.find(room => room.id === change);

    this._onTouched && this._onTouched(this.selectedRoom);
    this._onChange && this._onChange(this.selectedRoom);
  }

  public registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public writeValue(room: LimitedAssetRoomDTO): void {
    this.selectedRoom = room;
  }
}
